import React, { ReactNode } from 'react';
import { cn } from 'utils';
import { timelineLabelWidth } from './constants';
import { useTimeline } from './TimelineProvider';

/**
 * A container for the interactive hit space of the timeline. This lays on top of all the tracks in the timeline
 * and allows for selecting a desired point in the timeline to inspect.
 */
export function TimelinePositionHitspace(props: {
  children?: ReactNode;
}): React.ReactElement {
  const { children } = props;
  const { changeMarkerPosition } = useTimeline();
  const boxRef = React.useRef<HTMLButtonElement>(null);

  const onClickHitspace: React.MouseEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    if (!boxRef.current) return;

    const { pageX: clickX } = event;
    const { left: boxX, width: boxWidth } =
      boxRef.current.getBoundingClientRect();

    changeMarkerPosition((clickX - boxX) / boxWidth);
  };

  return (
    <button
      aria-label="Timeline hit space for interaction. Click to select a point in time to inspect"
      className={cn([
        'odin-absolute',
        'odin-cursor-pointer',
        'odin-select-none',
        'odin-bottom-0',
        'odin-right-0',
        'odin-top-0',
        'odin-ml-4',
        'odin-z-10',
      ])}
      onClick={onClickHitspace}
      ref={boxRef}
      style={{ left: timelineLabelWidth }}
      title="Click to interact with the timeline"
    >
      {children}
    </button>
  );
}
